import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "../../assets/scss/components/_email-verification.scss";
import CustomButton from "Components/Custom/CustomButton";

interface Props {
  isOpen: boolean;
  onClose?: () => void;
  onResendEmail?: () => void;
  email: string;
  isLoading?: boolean;
}

const EmailVerificationModal: React.FC<Props> = ({
  isOpen,
  email,
  onClose,
  onResendEmail,
  isLoading,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      centered
      fullscreen
      backdrop="static"
      fade={true}
      className="email-verification-modal"
    >
      <ModalHeader toggle={onClose} />

      <ModalBody className="d-flex flex-column justify-content-center align-items-center text-center p-4">
        <div className="icon-wrapper mb-4">
          <i className="ri-mail-send-line big-icon" />
        </div>

        <h2 className="title mb-3">Verify Your Email</h2>

        <p className="description">
          We have sent a verification link to:
          <br />
          <strong>{email}</strong>
        </p>

        <p className="description mt-3">
          Please verify your email address to continue using EaziQuote.
        </p>

        <CustomButton
          text="Resend Verification Email"
          className="br-50 bg-primary w-25"
          onClick={onResendEmail}
          loading={isLoading}
          disabled={isLoading}
        />
      </ModalBody>
    </Modal>
  );
};

export default EmailVerificationModal;
